import throttle from 'lodash/throttle';
import { useCallback, useEffect, useRef } from 'react';
/**
 * A utility hook to throttle a function. The return is the function, use for advanced cases where the usage of the
 * function directly is required.
 * @param callback
 * @param wait The number of milliseconds to throttle invocations to. If omitted in an environment with
 *  `requestAnimationFrame`, invocation will be deferred until the next frame is drawn (typically about 16ms).
 * @returns The throttled callback
 */ export function useThrottle(callback, wait) {
    const ref = useRef();
    useEffect(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    // Disabling exhaustive deps because this eslint rule gets confused when the
    // function passed to `useCallback` is not inlined.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttledCallback = useCallback(throttle((...args)=>{
        ref.current?.(...args);
    }, wait), []);
    return throttledCallback;
}

//# sourceMappingURL=use-throttle.js.map